import { Injectable } from '@angular/core'
import { CommonService } from '../../../../shared/services/common.service'

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  constructor(public commonService: CommonService) {}

  fetchSubjectforFeedback() {
    const urlparams = ['users', 'anonymous', 'feedbackform']
    const apiUrl = this.commonService.constructUrl(urlparams)
    return this.commonService.getData(apiUrl)
  }

  fetchDetailsFeedbackForm() {
    const urlparams = ['users', 'current', 'feedbackform']
    const apiUrl = this.commonService.constructUrl(urlparams)
    return this.commonService.getData(apiUrl)
  }

  submitGuestFeedback(formData) {
    const urlparams = ['users', 'anonymous', 'feedbackform']
    const apiUrl = this.commonService.constructUrl(urlparams)
    return this.commonService.postData(apiUrl, formData)
  }

  submitLoggedinUserFeedback(formData) {
    const urlparams = ['users', 'current', 'feedbackform']
    const apiUrl = this.commonService.constructUrl(urlparams)
    return this.commonService.postData(apiUrl, formData)
  }
}
